import React, { useContext } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UIContext } from '../../context/UIContext';
import { ADDRESS_DRAWER_WIDTH } from '../../constants';

const SideFormActions = ({
  cancelAction,
  isSubmitting = false,
}: {
  cancelAction: () => void;
  isSubmitting?: boolean;
}) => {
  const { t } = useTranslation();
  const { isMobile, iOS, colorMode } = useContext(UIContext);
  return (
    <Box
      sx={{
        display: 'flex',
        ...(!iOS && {
          width: `calc(${isMobile ? '100%' : `${ADDRESS_DRAWER_WIDTH}px`} - 32px)`,
          position: 'fixed',
          bottom: 0,
          right: 0,
          padding: '8px 16px',
          borderTop: (theme) =>
            `1px ${
              colorMode === 'light' ? theme?.palette?.grey?.['12p'] : theme?.palette?.grey?.['23p']
            } solid`,
        }),
        ...(iOS && {
          marginTop: 2,
        }),
        zIndex: 1,
        justifyContent: 'flex-end',
        backgroundColor: (theme) => theme?.palette?.background?.paper,
      }}
    >
      <Button
        color="primary"
        type="button"
        onClick={() => {
          if (!isSubmitting) cancelAction();
        }}
        sx={{ marginRight: '16px' }}
      >
        {t('actions.cancel')}
      </Button>
      <Button color="primary" variant="contained" type="submit" disableElevation>
        {isSubmitting && (
          <>
            <CircularProgress color="inherit" size="20px" sx={{ marginRight: '8px' }} />
            {t('actions.saving')}
          </>
        )}
        {!isSubmitting && t('actions.save')}
      </Button>
    </Box>
  );
};

export default SideFormActions;
